import type { ClassValue } from "clsx";
import { clsx } from "clsx";
import { toast } from "sonner";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(
  value: number,
  currency = "CAD",
  locale = "en-CA",
) {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  }).format(value);
}

interface ToastProps {
  title: string;
  description?: string;
  actionLabel?: string;
  onActionClick?: () => void;
  type?: "info" | "success" | "error" | "warning";
}

export function showToast({
  title,
  description,
  actionLabel,
  onActionClick,
  type,
}: ToastProps) {
  const config = {
    description,
    action: actionLabel
      ? {
          label: actionLabel,
          onClick: () => onActionClick?.(),
        }
      : undefined,
  };

  if (type === "success") return toast.success(title, config);
  if (type === "error") return toast.error(title, config);
  if (type === "warning") return toast.warning(title, config);
  if (type === "info") return toast.info(title, config);
  return toast(title, config);
}
